export const SiteInfo = {
  siteName: 'HotAliDeal.com',
  gaMeasurementId: 'G-WPY9DD8QW9',
  theme: 'light',
  adsenseClient: 'ca-pub-6653791084583982',
};